<template lang="pug">
  v-card.content-card-choice.choice-load.conf-choice(v-rc-loader="loading")
    v-layout.column.height
      v-dialog(width="50%" v-model="newMapOpen" persistent)
        v-card(v-rc-loader="createLoading")
          v-card-title.create-conf
            v-layout
              v-flex.xs10.offset-xs1
                .headline.text-xs-center.white--text.font-style-Roboto.font-weight-bold AJOUTER UNE CARTE
          v-card-text
            v-text-field.font-weight-bold(
              label="Nom de la carte"
              v-model="newMapName"
              :color="$route.query.context === 'choice' ? '#808080' : 'primary'"
            )
            v-textarea.font-weight-bold(
              label="Description"
              v-model="newMapDesc"
              :color="$route.query.context === 'choice' ? '#808080' : 'primary'"
            )
            v-layout.justify-end
              v-btn.grey--text(@click="newMapOpen = false") Annuler
              v-btn(color="#e7523e" dark @click="createConf") Créer
      v-dialog(width="50%" v-model="confirmeDelete" persistent)
        v-card(v-rc-loader="createLoading")
          v-card-title.create-conf
            v-layout
              v-flex.xs10.offset-xs1
                .headline.text-xs-center.white--text.font-style-Roboto.font-weight-bold Suppression de la configuration
          v-card-text
            v-layout.justify-center
              v-btn.grey--text(@click="confirmeDelete = false") Annuler
              v-btn(color="#e7523e" dark @click="deleteConfig()") Supprimer
      v-layout.align-center.mt-4
        v-flex.align-center
          v-flex.px-4
            v-layout.align-center
              img.ml-5(width="250px" src="@/assets/logo.png")
        v-flex
          v-btn.right.mr-5(
            color="#e7523e"
            width="40px" height="40px"
            depressed dark
            @click="newMapOpen = true"
          ) +
      ol.table.scrollable()
        li.item-container.header
          .cell.header-cell(v-for="items in headers") {{items.text}}
        li.item-container.row(v-for="props in configs")
          .cell
          .cell.first-column.icon() {{ props.id }}
          .cell(style="--column-width-min: 50px") {{ props.name }}
          .cell(style="--column-width-min: 50px") {{ props.description }}
          .cell(style="--column-width-min: 50px") {{ props.userName }}
          .cell {{ props.created | moment }}
          .cell {{ props.updated | moment }}
          .cell.image
            v-img.my-2(
              width="125px" height="125px"
              :src="`/api/v2/tmaps/configs/${props.id}/preview?t=${props.updated}`"
            )
          .cell.icon
            v-icon(@click="$router.push(`/maps/${props.id}?context=choice${addChosen()}`)") edit
          .cell.icon
            v-icon(v-if="!props.isDefault" @click="deleteConfig(props.id)") delete
          .cell.active-row(v-if="selected && props.id===selected.id") active
          button.cell.unactive-row(v-else @click="changeSelected(props)")
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/fr';

export default {

  data() {
    return {
      createLoading: false,
      newMapName: '',
      newMapDesc: '',
      newMapOpen: false,
      confirmeDelete: false,
      loading: true,
      deleteId: '',
      headers: [
        {
          text: '',
          value: 'statue',
        },
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Créé par',
          value: 'userId',
        },
        {
          text: 'Crée le',
          value: 'created',
        },
        {
          text: 'Mise à jour le',
          value: 'updated',
        },
        {
          text: 'Preview',
          value: '',
        },
        {
          text: '',
          value: '',
        },
        {
          text: '',
          value: '',
        },
      ],
      selected: null,
    };
  },
  filters: {
    moment(date) {
      const formattedDate = moment(date).format('ll').toString();
      const noDotDate = formattedDate.split('.').join('');
      const dateComps = noDotDate.split(' ');
      dateComps[1] = dateComps[1].replace(/^\w/, c => c.toUpperCase());
      return dateComps.join(' ');
    },
  },
  methods: {
    addChosen() {
      if (this.selected && this.selected.id) {
        return `&chosen=${this.selected.id}`;
      }
      return '';
    },
    changeSelected(conf) {
      this.$route.query.chosen = conf.id;
      this.selected = conf;
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage(conf.id, '*');
    },
    checkImage(imageSrc) {
      const http = new XMLHttpRequest();
      http.open('HEAD', imageSrc, false);
      http.send();
      return http.status !== 404;
    },
    createConf() {
      this.createLoading = true;
      const newParams = {
        isDefault: false,
        name: this.newMapName,
        description: this.newMapDesc,
        position: {
          latitude: 46.99573076463421,
          longitude: 2.578399338685542,
          zoom: 6,
        },
        theme: {
          colors: {
            primary: '#cdcdcd',
            secondary: '#cdcdcd',
          },
          icons: {
            default: true,
          },
          tint_intensity: 6,
        },
        icons: {
          disabled: [],
        },
        elements: {
          disabled: [],
        },
        map: {
          dragging: true,
          keyboardZoomOffset: true,
          scrollWheelZoom: 2,
          minZoom: 6,
          maxZoom: 18,
        },
        zoom: {
          state: true,
        },
        fullscreen: {
          state: true,
        },
        locate: {
          state: true,
        },
        geosearch: {
          state: true,
        },
        carto: {
          state: true,
        },
      };
      this.$store.dispatch('config/create', newParams).then((data) => {
        this.createLoading = false;
        this.selectedId = data.id;
        this.newMapOpen = false;
        // eslint-disable-next-line no-restricted-globals
        parent.postMessage(data.id, '*');
        setTimeout(() => { this.$router.push(`/maps/${data.id}?context=choice${this.addChosen()}`); }, 200);
      });
    },
    async deleteConfig(id) {
      if (id) {
        this.deleteId = id;
        this.confirmeDelete = true;
      } else {
        this.confirmeDelete = false;
        this.loading = true;
        await this.$store.dispatch('config/deleteById', this.deleteId);
        await this.$store.dispatch('config/get');
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$store.dispatch('config/get').then(() => { this.loading = false; });
    if (this.$route.params.selectedId) {
      axios.get(`/api/v2/tmaps/configs/${this.$route.params.selectedId}`).then((data) => { this.selected = data; });
    } else {
      this.showList = true;
    }
  },
  computed: {
    configs() {
      const chosenId = this.$route.query.chosen;
      if (chosenId) {
        const conf = this.$store.state.config.configs.find(x => x.id === chosenId);
        if (conf) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.selected = conf;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.selected.style = 'background-color: #FFF8F5;';
        }
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.config.configs.sort((a, b) => {
        if (this.selected) {
          if (a.id === this.selected.id) {
            return -1;
          }
          if (b.id === this.selected.id) {
            return 1;
          }
        }
        return 0;
      });
    },
  },
};
</script>

<style lang="scss">
  html{
    overflow: auto !important;
  }
  .headline{
    font-size: 22px !important;
  }
  .table{
    margin: 60px 60px;
    height: calc(100vh - 200px);
  }
  .scrollable{
    overflow-y: auto;
  }
  .height{
    max-height: 100%;
  }
  .item-container {
    display: grid;
    grid-template-columns: 15px 60px 1fr 2fr 2fr 125px 125px 125px 80px 80px 30px
  }
  .v-tabs__container{
    margin-left: 12px;
  }
  .header-cell {
    margin-bottom: 1px;
    font-family: Roboto,sans-serif;
    font-size: 16px !important;
  }
  .header :nth-child(2){
    justify-self: center;
    font-weight: bold;
  }
  .cell {
    margin-left: 10px;
    align-self: center;
    font-family: Roboto,sans-serif;
    font-size: 14px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(var(--column-width-min), 1fr));
  }
  .table .item-container:nth-child(2){
    background-color: #FFF8F5;
    border: 1px solid #e7523e;
    //border-radius: 20px;
  }
  .row {
    margin-bottom: 10px;
    justify-self: stretch;
    border-bottom: 1px solid #C1C0C0;
  }
  .choice-load .row:hover {
    background-color: #FFF8F5;
    border: 1px solid #e7523e;
  }
  .choice-load .row:hover .unactive-row{
    visibility: visible;
  }
  .unactive-row{
    margin-left: 0;
    width: 75vw;
    height: 143px;
    position: relative;
    right: 90vw;
    visibility: hidden;
  }
  .unactive-row:focus{
    outline: none!important;
  }
  .icon{
    justify-self: center;
  }
  .v-icon.v-icon.v-icon--link:hover{
    color: #e7523e;
  }
  .image{
    margin: 0;
  }
  .first-column {
    margin-left: 0;
    font-weight: bold;
  }
  .active-row {
    margin: 0;
    position: relative;
    width: 142px;
    height: 31px;
    justify-self: center;
    align-items: center;
    text-align: center;
    transform: rotate(90deg);
    font-size: 15px;
    color: white;
    background-color: #e7523e;
    letter-spacing: 4px;
  }

  .conf-choice {
    button.v-btn {
      &:not(.v-btn--floating) {
        min-width: 40px;
        height: 40px;
        padding: 0;
        border-radius: 20px;
      }
      font-size: 40px;
      font-weight: normal;
      text-transform: none;
      &.add-facet-open {
        text-transform: none;
      }
    }
  }
  .v-btn {
    &:not(.v-btn--depressed) {
      &:not(.v-btn--flat) {
        margin-top:50px;
        box-shadow:none;
      }
    }
  }
  .v-card__text{
    padding:40px;
  }
  .selected-banner {
    border-top: 1px solid lightgrey;
    border-bottom: 1px solid lightgrey;
  }
  .create-conf {
    background-color: #e7523e;
  }
  #map-choice {
    .map-option {
      border: 1px solid lightgrey;
      &:hover {
        opacity: 0.7;
      }
    }
    width: 100%;
  }
  .v-data-iterator__actions__select {
    display: none;
  }
  .v-data-iterator__actions__range-controls {
    padding-right: 44px;
    font-size: 20px;
    i {
      font-size: 34px;
    }
  }
  @media (max-width: 1135px) {
    .unactive-row {
      width: 65vw;
      right: 80vw;
    }
  }
</style>
